<template>
  <ul class="tabs">
    <li
      v-for="(t, idx) in props.tabList"
      :key="idx"
      :class="['tab', { active: idx === active }]"
      @click="() => $emit('update:active', idx)"
    >
      {{ t.tabName }}
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { ScenariosConfigData } from '~/api/interface'

const props = defineProps<{ tabList: ScenariosConfigData[]; active: number }>()
defineEmits(['update:active'])
</script>

<style lang="scss" scoped>
.tabs {
  display: inline-flex;
  gap: 24px;
  padding: 6px;
  background-color: var(--back-2);
  border-radius: 26px;
  .tab {
    cursor: pointer;
    padding: 8px 20px;
    min-width: 96px;
    text-align: center;
    border-radius: 18px;
    font-size: 14px;
    color: var(--text-1-60);
    font-weight: 500;
    &.active {
      background-color: var(--back-1);
      color: var(--text-1);
      font-weight: 600;
    }
  }
}
</style>
